// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u23C","toggle":"styles_toggle__3qpes","preview":"styles_preview__1N-dD"};